<template>
  <Table
    ref="table"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
  >
  </Table>
</template>

<script>
import { get, sync } from 'vuex-pathify';

import Table from '@/components/Table.vue';

export default {
  name: 'TableDma',
  components: {
    Table,
  },
  computed: {
    activeTool: sync('tools/activeTool'),
    layersFilters: get('layers/layersFilters'),
    dmaLayerId: get('admin/modulesMapping@billing.dma_layer_id'),
    customLayerData() {
      return {
        routeName: 'waterDissolutionDmaInfo',
        eventName: 'toggleDmaLayer',
        filterEventName: 'toggleDmaFilter',
        layerId: this.dmaLayerId,
      };
    },
  },
  methods: {
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
  },
  beforeCreate() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleDmaLayer', false);
    });
  },
};
</script>
